import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { NO_RESET_WHITE_LIST } from '@/constants'

// 导入模块化路由
import { constantRoutes } from './modules/constant'
import { asyncRoutes } from './modules/index'

// 创建路由实例
const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: [...constantRoutes, ...asyncRoutes] as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

// 重置路由方法
export const resetRouter = (): void => {
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !NO_RESET_WHITE_LIST.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

// 设置路由方法
export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

// 导出路由（新命名）
export { constantRoutes, asyncRoutes }

// 导出路由（旧命名，保持向后兼容）
export const constantRouterMap = constantRoutes
export const asyncRouterMap = asyncRoutes

export default router
